import { render } from "./previewComponent.vue?vue&type=template&id=ff131260"
import script from "./previewComponent.vue?vue&type=script&lang=js"
export * from "./previewComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\webencusco\\projects\\admin-carta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__